module.exports = __webpack_public_path__ + "media/vue/assets/images/icons/beauty-pass-gold-tier-ed4c3973a8cd0daa0bf7ca8cdb28ae39.png";